import { Routes } from '@angular/router';

import { RegisterCodePageComponent } from './containers/register-code-page.component';
import { RegisterContractPageComponent } from './containers/register-contract-page.component';
import { RegisterEmailPageComponent } from './containers/register-email-page.component';
import { RegisterPageComponent } from './containers/register-page.component';

export const routesRegister: Routes = [
  {path: 'email', component: RegisterEmailPageComponent, data: {animation: 'tiger'}},
  {path: 'code', component: RegisterCodePageComponent, data: {animation: 'tiger'}},
  {path: 'contract', component: RegisterContractPageComponent, data: {animation: 'tiger'}},
  {path: 'choose', component: RegisterPageComponent, data: {animation: 'tiger'}},
];





// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/register.routes.ts